<template>
  <v-dialog
    v-model="isShow"
    width="400px">
    <div class="dialog-container">
      <div class="plan-header">
        <div class="info flex">
          <span>Edit Email</span>
        </div>
      </div>
      <div class="dialog-body">
        <div
          class="flex-content">
          <el-form
            ref="form"
            :model="formData"
            :rules="rules">
            <div
              class="form-item ">
              <span>New email</span>
              <el-form-item
                ref="email"
                :rules="rules.contact_email"
                prop="email">
                <v-input v-model="formData.email"></v-input>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>
      <div class="flex footer-button">
        <v-button
          gray
          @click="isShow=false">Cancel</v-button>
        <v-button
          green
          @click="Confirm">Next</v-button>
      </div>
    </div>
  </v-dialog>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import MixinFormat from '@/mixins/format'

export default {
  name: 'eidtEmailDialog',
  mixins: [MixinOptions, MixinFormat,MixinRules],
  props: {
    value:{
      type:Boolean,
      default:false
    },
    form: {
      type: Object,
      default: () => ({})
    },},
  data() {
    return {
      isShow: false,
      formData:{
        email:''
      }
    }
  },
  computed:{
  },
  watch:{
    value:{
      immediate:true,
      handler(val){
        this.isShow = val
      }
    }
  },
  methods: {
    handlerComputed(){

    },
    Confirm() {
      this.$refs['form'].validate((valid, rules) => {
        if(valid) {
          this.$emit('next',this.formData.email)
          this.isShow = false
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog{
  border-radius: 4px;
}
.dialog-container {
  border-radius: 5px;
  .plan-header {
    background: #F6F8FA;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    .info{
      display: flex;
      justify-content: space-between;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      align-items: center;
      padding:16px;
      font-size: 14px;
      font-weight: 600;
      color: #24292E;
      border: 1px solid #E1E4E8;
      i{
        font-weight: 600;
        font-size: 14px;
      }
    }
  }
  .title-span{
    color: #24292E;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 20px;
  }
  .dialog-body{
    padding: 20px 15px;
  }
  .footer-button{
    padding:0 16px 16px 16px;
    padding-top: 0;
    justify-content: space-between;
  }
  .flex-content {
    .form-item{
      padding-bottom: 0;
    }
  }
}
</style>
